import { Control, Controller } from 'react-hook-form';
import { makeStyles, Paper, TextField } from '@material-ui/core';

import { CreateOrganizationFormValues } from './create-organization-form.type';

type Props = {
  control: Control<CreateOrganizationFormValues>;
};

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const useStyles = makeStyles({
  fieldsGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem 0.75rem',
  },
  flexRow: {
    display: 'flex',
    gap: '1rem',

    '& > *': {
      flex: 1,
    },
  },
});

export function NewContactForm({ control }: Props) {
  const classes = useStyles();

  return (
    <Paper className={classes.fieldsGroup}>
      <section className={classes.flexRow}>
        <Controller
          name="newContact.firstname"
          control={control}
          rules={{ required: 'Prénom requis', validate: (value) => value.trim().length > 0 || 'Prénom requis' }}
          render={({ field, fieldState }) => (
            <TextField
              label="Prénom"
              type="text"
              variant="outlined"
              fullWidth
              required
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              {...field}
            />
          )}
        />
        <Controller
          name="newContact.lastname"
          control={control}
          rules={{ required: 'Nom requis', validate: (value) => value.trim().length > 0 || 'Nom requis' }}
          render={({ field, fieldState }) => (
            <TextField
              label="Nom"
              type="text"
              variant="outlined"
              fullWidth
              required
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              {...field}
            />
          )}
        />
      </section>
      <Controller
        name="newContact.email"
        control={control}
        rules={{
          required: 'Email requis',
          pattern: { value: EMAIL_REGEX, message: 'Email invalide' },
        }}
        render={({ field, fieldState }) => (
          <TextField
            label="Email"
            type="email"
            variant="outlined"
            fullWidth
            required
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            {...field}
          />
        )}
      />
      <Controller
        name="newContact.phoneNumber"
        control={control}
        rules={{
          required: 'Téléphone requis',
          minLength: { value: 10, message: '10 chiffres requis' },
          maxLength: { value: 10, message: '10 chiffres requis' },
        }}
        render={({ field, fieldState }) => (
          <TextField
            label="Téléphone"
            type="tel"
            variant="outlined"
            fullWidth
            required
            inputProps={{ maxLength: 10 }}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            {...field}
          />
        )}
      />
    </Paper>
  );
}
